import { render, staticRenderFns } from "./DrawersDropdown.vue?vue&type=template&id=6cdc9aaa&"
import script from "./DrawersDropdown.vue?vue&type=script&lang=js&"
export * from "./DrawersDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports